import styled from 'styled-components';

export const LinkWrapper = styled.div`
  text-decoration: none;
`;
